import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Form, Button, Table, Alert, Spinner, Modal } from "react-bootstrap";

const ExpensesReport = () => {
  const [expenses, setExpenses] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [dateFilter, setDateFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  // Fetch all expenses
  const fetchExpenses = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/expenses/");
      setExpenses(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب المصروفات.");
    } finally {
      setLoading(false);
    }
  };

  // Filter expenses based on date and name
  const filteredExpenses = expenses.filter((expense) => {
    const matchesDate = dateFilter 
      ? expense.transaction_date.includes(dateFilter) 
      : true;
    
    const matchesName = nameFilter 
      ? expense.expense.name.toLowerCase().includes(nameFilter.toLowerCase()) 
      : true;
    
    return matchesDate && matchesName;
  });

  // Calculate total expenses
  const totalExpenses = filteredExpenses.reduce(
    (total, expense) => total + parseFloat(expense.amount),
    0
  ).toFixed(2);

  // Open details modal
  const viewExpenseDetails = (expense) => {
    setSelectedExpense(expense);
    setShowDetails(true);
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير المصروفات</h1>

      {/* Filters */}
      <div style={{ display: "flex", marginBottom: "20px", gap: "10px" }}>
      <Form.Control
         type="date"
         value={dateFilter}
         onChange={(e) => setDateFilter(e.target.value)}
         onFocus={(e) => e.target.style.color = "#000"}
         onBlur={(e) => {
            if (!e.target.value) e.target.style.color = "#aaa";
         }}
         style={{ maxWidth: "250px", color: dateFilter ? "#000" : "#aaa" }}
         />

        <Form.Control
          type="text"
          placeholder="الترتيب حسب اسم المصروف"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
          style={{ maxWidth: "250px" }}
        />
        <Button 
          variant="outline-secondary" 
          onClick={() => {
            setDateFilter("");
            setNameFilter("");
          }}
          style={{ border: "1px solid darkgreen", color: "darkgreen" }}
        >
          مسح الترتيب
        </Button>
      </div>

      {/* Summary Card */}
      <div style={{ 
        backgroundColor: "white", 
        padding: "15px", 
        marginBottom: "20px", 
        borderRadius: "5px",
        border: "1px solid darkgreen"
      }}>
        <h4 style={{ color: "darkgreen" }}>الملخص</h4>
        <p style={{ fontSize: "18px" }}>
          <strong>إجمالي المصروفات:</strong> ${totalExpenses}
        </p>
        <p>
          <strong>عدد المعاملات:</strong> {filteredExpenses.length}
        </p>
      </div>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Expenses Table */
        <Table hover responsive>
          <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th>#</th>
              <th>اسم المصروف</th>
              <th>المبلغ ($)</th>
              <th>التاريخ</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {filteredExpenses.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">لم يتم العثور على مصروفات</td>
              </tr>
            ) : (
              filteredExpenses.map((expense, index) => (
                <tr key={expense.id}>
                  <td>{index + 1}</td>
                  <td>{expense.expense.name}</td>
                  <td>${parseFloat(expense.amount).toFixed(2)}</td>
                  <td>{expense.transaction_date}</td>
                  <td>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => viewExpenseDetails(expense)}
                      style={{ border: "1px solid darkgreen", color: "darkgreen" }}
                    >
                      عرض التفاصيل
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}

      {/* Details Modal */}
      <Modal show={showDetails} onHide={() => setShowDetails(false)}>
        <Modal.Header closeButton style={{ backgroundColor: "darkgreen", color: "white" }}>
          <Modal.Title>تفاصيل المصروف</Modal.Title>
        </Modal.Header>
        {selectedExpense && (
          <Modal.Body>
            <p><strong>المعرف:</strong> {selectedExpense.id}</p>
            <p><strong>اسم المصروف:</strong> {selectedExpense.expense.name}</p>
            <p><strong>معرف المصروف:</strong> {selectedExpense.expense.id}</p>
            <p><strong>المبلغ:</strong> ${parseFloat(selectedExpense.amount).toFixed(2)}</p>
            <p><strong>تاريخ المعاملة:</strong> {selectedExpense.transaction_date}</p>
            <p><strong>ملاحظات:</strong> {selectedExpense.notes || "لا توجد ملاحظات"}</p>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => setShowDetails(false)}
            style={{ backgroundColor: "darkgreen", borderColor: "darkgreen" }}
          >
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ExpensesReport;